import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RemoveDoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remove_done"}/>
}
